export default __webpack_public_path__ + "static/media/kidney-orange.72523402.svg";